import {connect} from '../../app/connect';
import TemplateDuplicateModal from './TemplateDuplicateModal';
import {
  setDuplicateTemplateIdAction,
  resetTemplatesHighlightingRowsAction,
  showNotificationAction
} from '../../app/actions';
import {getCurrentDuplicateTemplateId, getTemplateEntitiesMap} from '../../app/selectors';

const mapStateToProps = state => {
  const duplicateTemplateId = getCurrentDuplicateTemplateId(state);
  return {
    duplicateTemplateId,
    duplicateTemplate: getTemplateEntitiesMap(state)[duplicateTemplateId]
  };
};

const mapDispatchToProps = {
  setDuplicateTemplateIdAction,
  resetTemplatesHighlightingRowsAction,
  showNotificationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateDuplicateModal);
